import React, { useEffect, useState } from 'react'
import { IoIosPrint } from 'react-icons/io';
import { useReactToPrint } from 'react-to-print';
import printIonicContent from '../../../../configurations/native/ionicPrint';
import { IsMobileEnv } from '../../../../configurations/initUrls';

export function PrintStarterDash({ printRef, text = "" }) {
    const [printCount, setPrintCount] = useState(0)

    useEffect(() => {
        if (printCount > 0) {
            if (IsMobileEnv)
                printIonicContent(printRef.current?.outerHTML)
            else
                handlePrint()
        }
    }, [printCount])
    const handlePrint = useReactToPrint({
        contentRef: printRef,
    });
    const initPrint = () => { setPrintCount(printCount + 1); }
    return (
        <button onClick={initPrint} className="btn-success" ><span className='flex items-center justify-center gap-2'><IoIosPrint /> <span>{text}</span></span></button>
    )
}
